<template>
  <el-dialog
    :title="title"
    :visible.sync="localVisible"
    width="700px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="deviceForm"
      :model="formData"
      :rules="formRules"
      label-width="110px"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="设备编号"
            prop="deviceCode"
          >
            <el-input
              v-model="formData.deviceCode"
              placeholder="请输入设备编号"
              maxlength="64"
              :disabled="type !== 'add'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="部件编号(zcbh)"
            prop="zcbh"
          >
            <el-input
              v-model="formData.zcbh"
              placeholder="云平台资产编号（可选）"
              maxlength="100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="设备名称"
        prop="deviceName"
      >
        <el-input
          v-model="formData.deviceName"
          placeholder="请输入设备名称"
          maxlength="100"
        />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="消防系统"
            prop="systemId"
          >
            <el-select
              v-model="formData.systemId"
              placeholder="请选择消防系统"
              style="width: 100%"
              :disabled="type !== 'add'"
              @change="handleFormSystemChange"
            >
              <el-option
                v-for="item in systemList"
                :key="item.uuid"
                :label="item.systemName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="设施类型"
            prop="deviceTypeId"
          >
            <el-select
              v-model="formData.deviceTypeId"
              placeholder="请选择设施类型"
              style="width: 100%"
              :disabled="type !== 'add'"
            >
              <el-option
                v-for="item in formTypeList"
                :key="item.uuid"
                :label="item.typeName"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="所属区域"
            prop="areaId"
          >
            <AreaCascader
              v-model="formData.areaId"
              :options="areaTree"
              placeholder="请选择所属区域"
              clearable
              :disabled="type !== 'add'"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        label="具体位置描述"
        prop="installLocation"
      >
        <el-input
          v-model="formData.installLocation"
          type="textarea"
          placeholder="如：东侧配电房北墙距地面2.5米处"
          maxlength="500"
        />
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="设备级别"
            prop="deviceLevel"
          >
            <el-select
              v-model="formData.deviceLevel"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                label="A级 - 重要设备"
                value="A"
              />
              <el-option
                label="B级 - 一般设备"
                value="B"
              />
              <el-option
                label="C级 - 普通设备"
                value="C"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="设备型号"
            prop="model"
          >
            <el-input
              v-model="formData.model"
              placeholder="设备型号（选填）"
              maxlength="50"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="设备品牌"
            prop="brand"
          >
            <el-input
              v-model="formData.brand"
              placeholder="设备品牌（选填）"
              maxlength="50"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="生产厂家"
            prop="manufacturer"
          >
            <el-input
              v-model="formData.manufacturer"
              placeholder="生产厂家（选填）"
              maxlength="50"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">
        取消
      </el-button>
      <el-button
        type="primary"
        :loading="submitting"
        @click="handleSubmit"
      >
        保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deviceService } from './device.service';
import AreaCascader from '@/features/gnmk/components/AreaCascader.vue';

export default {
  name: 'DeviceDialog',
  components: { AreaCascader },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    initialData: {
      type: Object,
      default: () => ({})
    },
    systemList: {
      type: Array,
      default: () => []
    },
    typeList: {
      type: Array,
      default: () => []
    },
    areaTree: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      submitting: false,
      formData: {
        uuid: '',
        deviceCode: '',
        deviceName: '',
        zcbh: '',
        systemId: '',
        deviceTypeId: '',
        areaId: '',
        installLocation: '',
        model: '',
        manufacturer: '',
        brand: '',
        deviceLevel: 'C',
        deviceStatus: 0
      },
      formRules: {
        deviceCode: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        systemId: [{ required: true, message: '请选择消防系统', trigger: 'change' }],
        deviceTypeId: [{ required: true, message: '请选择设施类型', trigger: 'change' }],
        areaId: [{ required: true, message: '请选择所属区域', trigger: 'change' }],
        deviceLevel: [{ required: true, message: '请选择设备级别', trigger: 'change' }]
      },
      formTypeList: []
    };
  },
  computed: {
    localVisible: {
      get () {
        return this.visible;
      },
      set (val) {
        this.$emit('update:visible', val);
      }
    },
    title () {
      return this.type === 'add' ? '新增设备' : '编辑设备';
    }
  },
  methods: {
    initForm () {
      if (this.type === 'add') {
        this.resetFormData();
      } else {
        this.formData = {
          uuid: this.initialData.uuid,
          deviceCode: this.initialData.deviceCode,
          deviceName: this.initialData.deviceName,
          zcbh: this.initialData.zcbh,
          systemId: this.initialData.systemId,
          deviceTypeId: this.initialData.deviceTypeId,
          areaId: this.initialData.areaId,
          installLocation: this.initialData.installLocation,
          model: this.initialData.model || '',
          manufacturer: this.initialData.manufacturer || '',
          brand: this.initialData.brand || '',
          deviceLevel: this.initialData.deviceLevel || 'C',
          deviceStatus: this.initialData.deviceStatus
        };
        // 加载对应系统的设施类型
        this.formTypeList = this.typeList.filter(t => t.systemId === this.formData.systemId);
      }
      this.$nextTick(() => {
        this.$refs.deviceForm && this.$refs.deviceForm.clearValidate();
      });
    },

    resetFormData () {
      this.formData = {
        uuid: '',
        deviceCode: '',
        deviceName: '',
        zcbh: '',
        systemId: '',
        deviceTypeId: '',
        areaId: '',
        installLocation: '',
        model: '',
        manufacturer: '',
        brand: '',
        deviceLevel: 'C',
        deviceStatus: 0
      };
      this.formTypeList = [];
    },

    handleFormSystemChange () {
      this.formData.deviceTypeId = '';
      this.formTypeList = this.typeList.filter(t => t.systemId === this.formData.systemId);
    },

    handleClose () {
      this.localVisible = false;
      this.$refs.deviceForm && this.$refs.deviceForm.resetFields();
    },

    handleSubmit () {
      this.$refs.deviceForm.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const submitData = { ...this.formData };
        const request = this.type === 'add'
          ? deviceService.addDevice(submitData)
          : deviceService.updateDevice(submitData);

        request.then(() => {
          this.$message.success('保存成功');
          this.localVisible = false;
          this.$emit('success');
        }).finally(() => {
          this.submitting = false;
        });
      });
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.initForm();
      }
    }
  }
};
</script>

<style scoped lang="scss">
// 弹窗表单样式
::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-form-item__error {
  position: relative;
  top: 0;
  padding-top: 2px;
}
</style>
